import React from "react";
import { Row, Typography } from "antd";
import { FormWrapper } from "./components/FormWrapper";
import { getAllUsersToSelect } from "Api/UsersApi/helpers";

const { Title } = Typography;

export const UserStep = ({
  users = [],
  onChange = () => {},
  roles = [],
  disabled = false,
}) => {
  return (
    <div style={{ margin: "0 auto" }}>
      <Title level={4} style={{ marginBottom: 24 }}>
        Призначення користувачів
      </Title>

      <Row gutter={[16, 16]}>
        <FormWrapper
          disabled={disabled}
          mode="multiple"
          customFetch={getAllUsersToSelect}
          title={"Інженери / керівний персонал"}
          workerType={"інженер"}
          description={
            "Особи які можуть переглядати дані проекту. Дивитись та передавати на нарахування бланки."
          }
          onChange={(e) => {
            const userIds = (Array.isArray(e) ? e : [])
              .filter(Boolean)
              .map((el) => el?.value ?? el)
              .filter(Boolean);
            const usersData = userIds.map((user) => {
              const json = user.split("___")[0];
              const raw = JSON.parse(json);
              return raw;
            });

            if (roles.length) {
              onChange({
                role: roles.find((elem) => elem.role === "інженер").id,
                users: usersData,
              });
            }
          }}
          value={Object.keys(users)
            .map((roleId) => {
              const someRole = roles.find((elem) => elem.role === "інженер").id;

              if (roleId === someRole) {
                return users[roleId].map((el) => {
                  return {
                    value: JSON.stringify(el) + `___` + el.id,
                    label: el.name,
                  };
                });
              }
              return [];
            })
            .flat()}
        />

        <FormWrapper
          disabled={disabled}
          mode="multiple"
          customFetch={getAllUsersToSelect}
          title={"Керівник робіт / Монтери"}
          workerType={"монтер"}
          description={
            "Особи які можуть формувати/заповнювати бланки та відправляти дані."
          }
          onChange={(e) => {
            const userIds = (Array.isArray(e) ? e : [])
              .filter(Boolean)
              .map((el) => el?.value ?? el)
              .filter(Boolean);
            const usersData = userIds.map((user) => {
              const json = user.split("___")[0];
              const raw = JSON.parse(json);
              return raw;
            });

            if (roles.length) {
              onChange({
                role: roles.find((elem) => elem.role === "монтер").id,
                users: usersData,
              });
            }
          }}
          value={Object.keys(users)
            .map((roleId) => {
              const someRole = roles.find((elem) => elem.role === "монтер").id;

              if (roleId === someRole) {
                return users[roleId].map((el) => {
                  return {
                    value: JSON.stringify(el) + `___` + el.id,
                    label: el.name,
                  };
                });
              }
              return [];
            })
            .flat()}
        />

        <FormWrapper
          disabled={disabled}
          mode="multiple"
          customFetch={getAllUsersToSelect}
          title={"Кошторисна інформація"}
          workerType={"кошторисник"}
          description={
            "Особи які отримують дані для нарахування ЗП та перевірки."
          }
          onChange={(e) => {
            const userIds = (Array.isArray(e) ? e : [])
              .filter(Boolean)
              .map((el) => el?.value ?? el)
              .filter(Boolean);
            const usersData = userIds.map((user) => {
              const json = user.split("___")[0];
              const raw = JSON.parse(json);
              return raw;
            });

            if (roles.length) {
              onChange({
                role: roles.find((elem) => elem.role === "кошторисник").id,
                users: usersData,
              });
            }
          }}
          value={Object.keys(users)
            .map((roleId) => {
              const someRole = roles.find(
                (elem) => elem.role === "кошторисник",
              ).id;

              if (roleId === someRole) {
                return users[roleId].map((el) => {
                  return {
                    value: JSON.stringify(el) + `___` + el.id,
                    label: el.name,
                  };
                });
              }
              return [];
            })
            .flat()}
        />
      </Row>
    </div>
  );
};
